/* eslint-disable react/prop-types */
import React from 'react';
import MdIcon from '~/shared/components/mdIcon';

import {
  PerfilContainer,
  Title,
  ContentBox,
  TopContainer,
  SubTitle,
  SubTitleContainer,
  Field,
  FieldContainer,
  FieldBox,
  ButtonIcon,
} from './styles';

const ProfileBox = ({
  title,
  subTitle,
  iconSubTitle,
  icon,
  colorSubTitle,
  color,
  setModalOpen,
}) => {
  return (
    <PerfilContainer>
      <Title>{title}</Title>
      <ContentBox>
        <TopContainer>
          <SubTitleContainer>
            <MdIcon size={0.9} icon={iconSubTitle} color={colorSubTitle} />
            <SubTitle>{subTitle}</SubTitle>
          </SubTitleContainer>
          <ButtonIcon onClick={() => setModalOpen()}>
            <MdIcon size={0.9} icon={icon} color={color} />
          </ButtonIcon>
        </TopContainer>
        <FieldBox>
          <FieldContainer>
            <Field>
              Nome: <strong>Alexandre Soares da Costa</strong>
            </Field>
            <Field>
              E-mail: <strong>alexandre.costa@email.com</strong>
            </Field>
            <Field>
              CRF: <strong>123.456.789</strong>
            </Field>
          </FieldContainer>
          <FieldContainer>
            <Field>
              Telefone: <strong>(11) 98765-4321</strong>
            </Field>
            <Field>
              UF CRF: <strong>São Paulo</strong>
            </Field>
          </FieldContainer>
        </FieldBox>
      </ContentBox>
    </PerfilContainer>
  );
};

export default ProfileBox;
